import React from 'react';

// Barra de desplazamiento horizontal superior para tablas anchas. Se sincroniza
// con el contenedor de la tabla mediante el hook useHorizontalScrollSync.
// En el celular se oculta (las tablas se ven como tarjetas).
const TopScrollbar = ({ scrollRef, onScroll, width }) => (
  <div
    ref={scrollRef}
    onScroll={onScroll}
    className="axon-top-scrollbar"
    style={{ overflowX: 'auto', marginBottom: '5px', width: '100%' }}
  >
    <div style={{ width, height: '1px' }} />
  </div>
);

export default TopScrollbar;
